"use client";

import { useEffect } from "react";

export default function Error({
  error
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div>
      {/* Keeps a failed page out of the search index. React hoists this into
          <head>; the surrounding layout and its real <title> stay intact. */}
      <meta name="robots" content="noindex, nofollow" />
      <div className="flex flex-col justify-center items-center h-[calc(100vh-200px)]">
        <h1 className="homepage-text-xl">Oops...</h1>
        <h2 className="homepage-text-lg">Something went wrong!</h2>
      </div>
    </div>
  );
}
